var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'pc': !_vm.isMobile, 'mobile': _vm.isMobile, 'E': _vm.lang === 'E'},attrs:{"id":"app"}},[_c('div',{ref:"layer",attrs:{"id":"layer"}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }